module.exports = __webpack_public_path__ + "img/title-bg.92069840.png";